/* eslint-disable @typescript-eslint/no-explicit-any */
import { Chart } from "primereact/chart";
import { useAssetContext } from "../../contexts/AssetContext";
import { useEffect, useMemo, useRef } from "react";

export default function AssetsDoughnutChart() {
    const assetContext = useAssetContext();
    const updatedTimes = useRef<number>(0);

    useEffect(() => {
        updatedTimes.current = updatedTimes.current! + 1;
    }, [assetContext.assets]);

    const chartData = useMemo(() => ({
        labels: [...assetContext.assets.map(a => a.name)],
        datasets: [
            {
                data: [
                    ...assetContext.assets.map(a => a.value)
                ],
                backgroundColor: [
                    ...assetContext.assets.map(a => a.color)
                ],
                hoverBackgroundColor: [
                    ...assetContext.assets.map(a => a.hoverColor)
                ]
            }
        ]
    }), [assetContext.assets]);

    const chartOptions = useMemo(() => ({
        cutout: '70%',
        animation: {
            duration: updatedTimes.current > 1 ? 0 : 1000
        },
        plugins: {
            tooltip: {
                callbacks: {
                  label: function (context: any) {
                    const value = context.raw || 0;
                    const formattedValue = new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(value);

                    return ` ${formattedValue}`;
                  },
                },
            },
            legend: {
                display: false
            }
        }
    }), [updatedTimes.current]);

    return (
        <Chart 
            type="doughnut" 
            data={chartData} 
            options={chartOptions} 
            className="flex z-1 justify-content-center align-items-center w-15rem" 
        />
    )
}